<!-- HTML BODY -->
<div *ngIf="!isLoading()" [innerHTML]="config.emailHtml"></div>
<mat-spinner *ngIf="isLoading()"></mat-spinner>